<div class="@container flex min-h-0 flex-col gap-5">
  @if (diagnosesOption(); as option) {
    <div class="grid grid-cols-1 items-center gap-4 @2xl:grid-cols-2">
      <div class="flex min-w-0 items-center gap-2">
        <button
          class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-500"
          type="button"
          [matTooltip]="'general.action.back' | translate"
          (click)="closeDiagnoses()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="truncate font-bold text-neutral-500">{{ option.name }}</span>
        <insurance-packages-diagnoses-count-badge [count]="option.diagnosesCount"></insurance-packages-diagnoses-count-badge>
      </div>
      <div class="relative">
        <mat-icon class="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-neutral-300">search</mat-icon>
        <input
          class="w-full rounded-xl border border-neutral-200 py-2.5 pr-3 pl-10 outline-none focus:border-primary-300"
          type="text"
          [value]="diagnosesSearch()"
          [placeholder]="'packageCoverage.message.diagnosesSearchPlaceholder' | translate"
          (input)="diagnosesSearch.set($any($event.target).value)"
        />
      </div>
    </div>

    @if (diagnosesLoading()) {
      <div class="flex justify-center py-6">
        <shared-loader></shared-loader>
      </div>
    } @else if (diagnosesError()) {
      <div class="flex items-center gap-2">
        <span class="text-error-500">{{ "packageCoverage.message.diagnosesLoadError" | translate }}</span>
        <button
          class="cursor-pointer font-bold text-primary-500 hover:text-primary-600"
          type="button"
          (click)="loadDiagnoses()"
        >
          {{ "packageConfigurator.action.retry" | translate }}
        </button>
      </div>
    } @else {
      <tasks-member-coverage-diagnoses
        [codes]="diagnoses()"
        [search]="diagnosesSearch()"
      ></tasks-member-coverage-diagnoses>
    }
  } @else {
    <div class="relative">
      <mat-icon class="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-neutral-300">search</mat-icon>
      <input
        class="w-full rounded-xl border border-neutral-200 py-2.5 pr-3 pl-10 outline-none focus:border-primary-300"
        type="text"
        [value]="search()"
        [placeholder]="'packageConfigurator.message.optionsSearchPlaceholder' | translate"
        (input)="search.set($any($event.target).value)"
      />
    </div>

    <section class="flex min-h-0 flex-col overflow-hidden rounded-[18px] border border-neutral-100 bg-neutral-0 shadow-[0_8px_24px_rgb(0_0_0/0.06)]">
      <div class="max-h-[60vh] min-h-0 overflow-auto text-sm">
        @for (option of visibleOptions(); track option.id) {
          <div
            class="flex flex-col gap-2 border-b border-neutral-100 bg-neutral-50 px-3.5 py-2 @4xl:grid @4xl:grid-cols-[minmax(0,1fr)_11rem_10rem_16rem] @4xl:items-start @4xl:gap-4"
          >
            <div class="flex min-w-0 flex-col gap-1">
              <div class="flex items-center gap-2">
                @if (option.subOptions?.length) {
                  <button
                    class="inline-flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center text-neutral-400"
                    type="button"
                    (click)="toggleOption(option.id)"
                  >
                    <mat-icon class="mt-0.5 text-center text-sm">{{ isOptionCollapsed(option.id) ? "chevron_right" : "expand_more" }}</mat-icon>
                  </button>
                } @else {
                  <span class="w-6 shrink-0"></span>
                }
                <span class="font-bold text-neutral-500">{{ option.name }}</span>
              </div>
              @if (option.diagnosesCount) {
                <button
                  class="group ml-8 w-fit cursor-pointer rounded-full"
                  type="button"
                  (click)="openDiagnoses(option)"
                >
                  <insurance-packages-diagnoses-count-badge
                    class="group-hover:bg-purple-200"
                    [count]="option.diagnosesCount"
                  ></insurance-packages-diagnoses-count-badge>
                </button>
              }
              @if (option.description) {
                <span class="pl-8 text-xs text-neutral-300">{{ option.description }}</span>
              }
            </div>
            <div class="flex flex-wrap items-start gap-x-3 gap-y-2 pl-8 @lg:grid @lg:grid-cols-[8rem_7rem_minmax(0,1fr)] @4xl:contents">
              <insurance-packages-coverage-limits [limits]="option.limits"></insurance-packages-coverage-limits>
              <insurance-packages-clinic-class-summary
                [clinicClasses]="option.clinicClasses"
                [matTooltip]="'packageConfigurator.label.clinicClassesTitle' | translate"
              ></insurance-packages-clinic-class-summary>
              <insurance-packages-coverage-categories
                [categories]="option.categories"
                [expanded]="areCategoriesExpanded(option.id)"
                (expandedChange)="toggleCategories(option.id)"
              ></insurance-packages-coverage-categories>
            </div>
          </div>

          @if (!isOptionCollapsed(option.id)) {
            @for (subOption of option.subOptions; track subOption.id) {
              <div
                class="flex flex-col gap-2 border-b border-neutral-100 px-3.5 py-2 hover:bg-primary-50 @4xl:grid @4xl:grid-cols-[minmax(0,1fr)_11rem_10rem_16rem] @4xl:items-start @4xl:gap-4"
              >
                <div class="flex min-w-0 flex-col gap-1 pl-11">
                  <span class="text-neutral-400">{{ subOption.name }}</span>
                  @if (subOption.description) {
                    <span class="text-xs text-neutral-300">{{ subOption.description }}</span>
                  }
                </div>
                <div class="flex flex-wrap items-start gap-x-3 gap-y-2 pl-8 @lg:grid @lg:grid-cols-[8rem_7rem_minmax(0,1fr)] @4xl:contents">
                  <insurance-packages-coverage-limits [limits]="subOption.limits"></insurance-packages-coverage-limits>
                  <span class="hidden min-h-7.5 items-center text-neutral-200 @lg:flex">—</span>
                  <insurance-packages-coverage-categories
                    [categories]="subOption.categories"
                    [expanded]="areCategoriesExpanded(subOption.id)"
                    (expandedChange)="toggleCategories(subOption.id)"
                  ></insurance-packages-coverage-categories>
                </div>
              </div>
            }
          }
        } @empty {
          <p class="px-3.5 py-3 text-neutral-300">{{ "packageCoverage.message.noOptions" | translate }}</p>
        }
      </div>
    </section>
  }
</div>
